import type { StoreProductListParams } from '../api/store-catalog-api';

/** Store-scoped keys: everything hangs off the store so switching stores never shares cache. */
export const storeCatalogKeys = {
  all: (storeId: string) => ['stores', storeId, 'catalog'] as const,
  lists: (storeId: string) => [...storeCatalogKeys.all(storeId), 'list'] as const,
  list: (storeId: string, params: StoreProductListParams) =>
    [...storeCatalogKeys.lists(storeId), params] as const,
  details: (storeId: string) => [...storeCatalogKeys.all(storeId), 'detail'] as const,
  detail: (storeId: string, id: string) => [...storeCatalogKeys.details(storeId), id] as const,
  pricing: (storeId: string, id: string) =>
    [...storeCatalogKeys.detail(storeId, id), 'pricing'] as const,
  /** One product's fixed prices in one market. */
  marketPrices: (storeId: string, marketId: string, productId: string) =>
    [...storeCatalogKeys.all(storeId), 'market-prices', marketId, productId] as const,
  /** Whether one master product is in the store: a list filtered by productId. */
  membership: (storeId: string, productId: string) =>
    [...storeCatalogKeys.lists(storeId), 'membership', productId] as const,
  /**
   * Rotations the schedule filter offers (those targeting the store), and one rotation looked up
   * by id. Schedules are organisation-level, so these hang off `['org', 'schedules']` and refetch
   * whenever a schedule changes.
   */
  scheduleOptions: (storeId: string, q: string) =>
    ['org', 'schedules', 'filter-options', storeId, q] as const,
  scheduleOption: (id: string) => ['org', 'schedules', 'filter-options', 'id', id] as const,
};
